var map = {
	"./accenture.png": 8393,
	"./airtel.png": 656,
	"./anchor.png": 7757,
	"./ansalAPI.png": 2316,
	"./c&s.png": 4199,
	"./delhivery.png": 6431,
	"./expersion.png": 8363,
	"./fortis.png": 5228,
	"./gannon.png": 2967,
	"./iffco-tokio.png": 6483,
	"./iffco.png": 3837,
	"./indus.png": 8681,
	"./isgec.png": 2553,
	"./m3m.png": 7000,
	"./marathon.png": 4685,
	"./masco.png": 5089,
	"./metalsa.png": 3901,
	"./msl.png": 6875,
	"./omaxe.png": 1449,
	"./openKM-Partners.png": 9144,
	"./oyo.png": 4764,
	"./policybazaar.png": 1366,
	"./pwc.png": 3371,
	"./rblBank.png": 6115,
	"./revent.png": 1425,
	"./sandhar.png": 1659,
	"./sis.png": 8932,
	"./snapdeal.png": 7422,
	"./uflex.png": 6661,
	"./vatika.png": 7666,
	"./winsome.png": 1406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2235;